import React from 'react';

type BrandNameProps = {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
};

const sizeClasses = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-3xl',
  xl: 'text-4xl',
};

/** Product name: HIVE (white) + AIQ (amber). */
const BrandName: React.FC<BrandNameProps> = ({ className = '', size = 'lg' }) => (
  <span className={`font-bold tracking-tight ${sizeClasses[size]} ${className}`}>
    <span className="text-white">HIVE</span>
    <span className="text-amber-400">AIQ</span>
  </span>
);

export default BrandName;
